var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPostSkeletonM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 374,
    height: 161,
    viewBox: "0 0 374 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35929_60289)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 160,
    transform: "translate(-1 0.640015)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 24.64,
    width: 24,
    height: 24,
    rx: 12,
    fill: "url(#paint0_linear_35929_60289)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 28.64,
    width: 110,
    height: 16,
    rx: 4,
    fill: "url(#paint1_linear_35929_60289)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 28.64,
    width: 51,
    height: 16,
    rx: 4,
    fill: "url(#paint2_linear_35929_60289)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 72.64,
    width: 311,
    height: 24,
    rx: 4,
    fill: "url(#paint3_linear_35929_60289)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 108.64,
    width: 311,
    height: 12,
    rx: 4,
    fill: "url(#paint4_linear_35929_60289)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 132.64,
    width: 196,
    height: 12,
    rx: 4,
    fill: "url(#paint5_linear_35929_60289)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_35929_60289",
    x1: 55,
    y1: 36.8505,
    x2: 31,
    y2: 36.8505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_35929_60289",
    x1: 101,
    y1: 36.6399,
    x2: 190.714,
    y2: 36.5615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_35929_60289",
    x1: 179,
    y1: 36.6399,
    x2: 251,
    y2: 36.6107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_35929_60289",
    x1: 48.6371,
    y1: 84.1394,
    x2: 348.738,
    y2: 84.1758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_35929_60289",
    x1: 24.0112,
    y1: 114.64,
    x2: 348.738,
    y2: 114.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_35929_60289",
    x1: 54.8467,
    y1: 138.39,
    x2: 269,
    y2: 138.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35929_60289"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 160,
    fill: "white",
    transform: "translate(-1 0.640015)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostSkeletonM);
export default __webpack_public_path__ + "static/media/post-skeleton-m.ec1497105c9444bd8c0537ca580621c5.svg";
export { ForwardRef as ReactComponent };